import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {  isValidLinkedInURL, isValidStrongPassword, getPasswordValidationMessage } from "../../utils/validators";
import {fetchEmployerDetailbyID, updateEmployerProfile} from "../../api/EmployerAPI";
import {updateUserById} from "../../api/UserAPI";
import "../../assets/css/passwordInput.css";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext"; // adjust path
import jbAPI from "../../api/jobboard";


export default function HrProfileForm() {
  const [message, setMessage] = useState({ type: "", text: "" });
  const [errors, setErrors] = useState({});
  const { state } = useLocation();
  const navigate = useNavigate();
  const employerDet = state?.employerDet;
  const token = localStorage.getItem("otoken");
  const fullName = localStorage.getItem("name");
  const profilePic = localStorage.getItem("profilePic");
  const employerId = localStorage.getItem("aUId");
  const [formData, setFormData] = useState(state?.employerDet?.employer || {});

  const { setProfilePic } = useContext(UserContext);
  
  

const handleChange = (e) => {
  const { name, type, checked, value, files } = e.target;

  let fieldValue;

  if (type === "checkbox") {
    fieldValue = checked;
  } 
  
  
  
 else if (type === "file") {
    const file = files && files[0];
    if (file) {
      // ✅ Store the File object correctly
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // ✅ Generate preview (optional)
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          logoPreview: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
    return;
  } 

  else {
    fieldValue = value;
  }

  // console.log("🔧 Changed:", name, "→", fieldValue);


  setFormData((prev) => ({
    ...prev,
    [name]: fieldValue,
  }));

  // LinkedIn validation
  if (name === "linkedin_url") {
    if (!isValidLinkedInURL(value)) {
      setErrors((prev) => ({ ...prev, linkedin_url: "Invalid LinkedIn URL" }));
    } else {
      setErrors((prev) => ({ ...prev, linkedin_url: "" }));
    }
  }
};

  const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        const token = localStorage.getItem("otoken");
        const userId = localStorage.getItem("uId");
        
        //  console.log(formData.auth_user_profile_pic_url instanceof File); // should be true
        //  console.log("📸 Is file a File?", formData.auth_user_profile_pic_url instanceof File);

        // console.log("FORM DATA : ", formData);
        // 🔹 Step 1: Update user (including profile pic via FormData)
        
        
        const allowedFields = [
          "auth_user_profile_pic_url",
          "auth_user_account_status",
          "auth_user_email_verified",
          "auth_user_phone_verified",
          "auth_user_signup_method",
          "auth_userRole"
        ];

        const userFormData = new FormData();

        allowedFields.forEach((key) => {
          if (formData[key] !== undefined && formData[key] !== null) {
            console.log(`✅ ${key}:`, formData[key]);
            userFormData.append(key, formData[key]);
          } else {
            console.warn(`⛔ Skipping ${key} — value is null or undefined`);
          }
        });


        const payload =
          formData.auth_user_profile_pic_url instanceof File
            ? (() => {
              const form = new FormData();
              for (let key in formData) {
                if (formData[key] !== null && formData[key] !== undefined) {
                  form.append(key, formData[key]);
                }
              }
              return form;
            })()
            : formData;
        if (
          profilePic === null ||
          profilePic === "" ||
          profilePic === undefined ||
          (formData.auth_user_profile_pic_url instanceof File)
        ) {
          const res = await updateUserById(userId, payload, token);
          console.log("res.updatedFields ::: ", res);
          // If the response contains the new profile image filename:
          if (res.updatedFields?.auth_user_profile_pic_url) {
            const imagePath = res.updatedFields.auth_user_profile_pic_url;
            const imageUrl = imagePath ? `${process.env.REACT_APP_C2AS_UPLOAD_URL}/${imagePath}` : null;
            localStorage.setItem("profilePic", imageUrl); // ✅ Save to localStorage

            setProfilePic(imageUrl);
          }
        }

        // 🔹 Step 2: Update employer details (JSON body)
        const employerPayload = {
          employer_id: employerId,
          designation: formData.designation,
          linkedin_url: formData.linkedin_url,
          availability_status: formData.availability_status,
          email_notification: formData.email_notification ? "yes" : "no",
          in_app_notification: formData.in_app_notification ? "yes" : "no",
        };

        await updateEmployerProfile(employerId, employerPayload, token);
         localStorage.setItem("availability", formData.availability_status);
        alert("Profile updated successfully!");
      } catch (err) {
        console.error("Profile update error:", err);
        alert("Failed to update profile");
      }
  };

  useEffect(() => {
  const fetchData = async () => {
    console.log("Calling fetchEmployerDetailbyID");
    try {
      const data = await fetchEmployerDetailbyID(employerId, token);
      // setEmployerDet(data);

      const emp = data?.employer || {};

      setFormData({
        auth_user_profile_pic_url: null, // User hasn't uploaded a new file yet
        logoPreview: localStorage.getItem("profilePic") || null,
        fullName: fullName || "",
        email: emp.email || "",
        phone: emp.phone_number || "",
        designation: emp.designation || "",
        linkedin_url: emp.linkedin_url || "",
        availability_status: emp.availability_status || "available",
        email_notification: emp.email_notification === "yes",
        in_app_notification: emp.in_app_notification === "yes",
      });

      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    fetchData();
  }, [employerId, token, fullName]);


  // useEffect(() => {

  //    const fetchData = async () => {
  //       console.log("Calling fetchEmployerDetailbyID");
  //       try {
  //         const data = await fetchEmployerDetailbyID(appUserId, token);
  //         setEmployerDet(data);
  //       } catch (error) {
  //         console.error("API failed:", error);
  //         setMessage({ type: "error", text: "Could not load profile" });
  //       }
  //     };
    
  //     fetchData();
  //   }, []);

  //   if (!employerDet) {
  //     navigate("/employer/employer-profile/profile");
  //   }

  //   if (employerDet?.employer) {
  //     const emp = employerDet.employer;
  //     console.log("EMP ::: ", emp);
  //       setFormData({
  //         auth_user_profile_pic_url: null, // Start empty
  //         logoPreview: localStorage.getItem("profilePic") || null,
  //         fullName: fullName || "",
  //         email: emp.email || "",
  //         phone: emp.phone_number || "",
  //         designation: emp.designation || "",
  //         linkedin_url: emp.linkedin_url || "",
  //         availability_status: emp.availability_status || "available",
  //         email_notification: emp.email_notification === "yes",
  //         in_app_notification: emp.in_app_notification === "yes",
  //     });
  //   }
  // }, [employerDet, navigate, fullName]);


  if (!employerDet) return null;
  return (
     <div className="content-body">
      <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="javascript:void(0)">Manage Employer</a>
            </li>
            <li className="breadcrumb-item active">
              <a href="javascript:void(0)">Edit Profile</a>
            </li>
          </ol>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
              <div className={`alert alert-${message.type} mt-3`} role="alert">
                        {message.text}
                </div>
                <div className="form-validation">
                    <form className="form-validate" onSubmit={handleSubmit}>
                      <h4 className="card-title">Personal Information</h4>
                      <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="companyLogo">
                       Profile Picture <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                          {/* Round Profile Display */}
                          <div
                            className="bg-light d-flex align-items-center justify-content-center rounded-circle overflow-hidden mb-3"
                            style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%", // 🔴 Makes the shape round
                            overflow: "hidden",  // 🔒 Clips the image inside the circle
                            backgroundColor: "#f0f0f0", // fallback background
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          >
                            {(formData.logoPreview || profilePic) ? (
                              <img
                                src={formData.logoPreview || profilePic}
                                alt="Profile"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <i className="fa fa-user text-muted fa-2x" />
                            )}
                          </div>

                          
                          <input
                            type="file"
                            src={formData.logoPreview}
                            name="auth_user_profile_pic_url"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                setFormData((prev) => ({
                                  ...prev,
                                  auth_user_profile_pic_url: file,
                                  logoPreview: URL.createObjectURL(file)
                                }));
                              }
                            }}
                          />


                        </div>

                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="fullName">
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            className="form-control"
                            type="text"
                            name="fullName"
                            value={fullName}
                            onChange={handleChange}
                            placeholder="Enter a username.."
                            readOnly="readOnly"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="designation">
                          Designation <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            className="form-control"
                            type="text"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                            placeholder="Enter your Designation.."
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="emailId">
                          Email ID <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            className="form-control"
                            type="text"
                            name="email"
                            value={employerDet?.employer?.email || ''}
                            onChange={handleChange}
                            placeholder="Enter your Email ID.."
                            readOnly="readOnly"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="phone">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            className="form-control"
                            type="text"
                            name="phone"
                            value={formData.phone_number}
                            onChange={handleChange}
                            placeholder="Enter your Mobile number.."
                            readOnly="readOnly"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="linkedin_url">
                          Linkedin URL <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            className={`form-control  ${errors.linkedin_url ? "is-invalid" : ""}`}
                            type="text"
                            name="linkedin_url"
                            value={formData.linkedin_url}
                            onChange={handleChange}
                            placeholder="Enter your linkedin url.."
                          />
                           {errors.linkedin_url && (
                              <small className="text-danger">{errors.linkedin_url}</small>
                            )}
                        </div>
                      </div>

                     
                      <h4 className="card-title">Notification Preferences</h4>
                      <div className="form-group row">                        
                        <label className="col-lg-4 col-form-label" htmlFor="notification_preferences">Notification Preferences</label>
                        <div className="col-lg-6">
                          <div className="form-check form-check-inline">
                            <label className="form-check-label">
                            <input type="checkbox" name="email_notification" className="form-check-input" checked={formData.email_notification} onChange={handleChange}/>Email</label>
                          </div>
                          <div className="form-check form-check-inline disabled">
                              <label className="form-check-label">
                              <input type="checkbox" name="in_app_notification" className="form-check-input" checked={formData.in_app_notification} onChange={handleChange}/>In-app</label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="availability_status">
                          Availability Status <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="availability_status"
                            value={formData.availability_status}
                            onChange={handleChange}
                            className="w-full mt-1 p-2 border rounded"
                          >
                            <option value="available">Available</option>
                            <option value="donotdisturb">Do Not Disturb</option>
                            <option value="onleave">On Leave</option>
                          </select>

                        </div>
                      </div>
                      
                        <div className="col-12 d-flex justify-content-end">
                          <button type="submit" className="btn btn-primary mr-2">Save Changes</button>
                          <button type="button" className="btn btn-secondary mr-2" onClick={() => navigate("/employer/employer-profile/profile")}>Cancel</button>
                        </div>

                   
                    </form>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
  );
}
